
import { i18nText } from '@/locales';

//@ts-ignore
import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {FinanceOperationsTableMix} from "@/UI/mixins/Store/FinanceOperationsTableMix";
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue";
import {FiltersData} from "@/entity/filters/extFilter";
import {mixins} from "vue-class-component";
import {FormMix} from "@/UI/mixins/FormMix";
import {FinanceOperationsStore} from "@/store/modules/Finance/FinanceOperations";
import {CashboxStore} from "@/store/modules/Finance/Cashbox";
import {RouterNameEnum} from "@/router/router.types";
import {VisitsStore} from "@/store/modules/Visits";
import {ProxyGetData} from "../Helpers/getData";
import moment from 'moment';
import {getStudioId} from "@/UI/lib/state";
import {ClientsStore} from "@/store/modules/Clients";
import {PaymentArticlesStore} from "@/store/modules/PaymentArticles";
import {CounterpartiesStore} from "@/store/modules/Counterparties";
import {WorkersStore} from "@/store/modules/Workers";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import {AppStateStore} from "@/store/modules/appState";

@Component({
  components: {
    PageTitle,
    SortComponent,
    FilterTableComponent
  },
  methods: {
    moment
  }
})

export default class SalonsFinance extends mixins(
  //FormMix,
  ProxyGetData,
  FinanceOperationsTableMix
) {
  filtersData = new FiltersData()
  salon = Vue.router.currentRoute.params.id
  RouterNames = RouterNameEnum;
  filter_load: boolean = false;
  financeOperation_type: any = [
    {label: i18nText("Не указано"), key: '0'},
    {label: i18nText("Расход"), key: "1"},
    {label: i18nText("Доход"), key: "2"}
  ]

  // Отслеживаем скролл и если открыта сортировка, то скрываем ее при скролле
  beforeMount() {
    const scrollr = document.querySelector('.layout ') as HTMLElement;
    if (scrollr) {
      scrollr.addEventListener('scroll', this.handleWindowScroll);
    }
  }

  beforeDestroy() {
    const scrollr = document.querySelector('.layout ') as HTMLElement;
    if (scrollr) {
      scrollr.removeEventListener('scroll', this.handleWindowScroll);
    }
  }

  handleWindowScroll() {
    const elements = document.querySelectorAll('.ant-dropdown') as NodeListOf<HTMLElement>;

    elements.forEach(element => {
      const existingStyle = element.getAttribute('style');
      if (!existingStyle || !existingStyle.includes('display')) {
        element.style.display = 'none';
      }
    });
  }


  sort(by: any, column: any) {
    if (column.dataIndex === 'sum') {
      column.dataIndex = 'amount'
    }
    this.sortedData(by, column)
  }

  async showVisit(record: any) {
    await VisitsStore.fetchData({filter: {id: record.visit.id}})
    let data = VisitsStore.visit as any
    await Vue.router.push({
      name: RouterNameEnum.VisitsNewStatus,
      params: {
        Studio: this.salon,
        Worker: data["staff"]["id"],
        params: JSON.stringify(data),
        id: data["id"],
        mode: "status",
      },
    })
  }

  get clients(): any {
    return ClientsStore.clients?.data
  }

  get paymentArticles(): any {
    return PaymentArticlesStore.paymentArticles?.data
  }

  get counterparties(): any {
    return CounterpartiesStore.counterparties?.data
  }

  get workers(): any {
    return WorkersStore.workers?.data
  }

  get financeOperations(): any {
    return FinanceOperationsStore.items?.data
  }

  get cashboxes(): any {
    return CashboxStore.items?.data
  }

  async created(): Promise<void> {
    try {
      this.proxyFilter = {
        salon_id: this.salon
      }
      await this.fetchModules([
        {s: 'counterparties', p: {limit: -1, filter: {salon_id: this.salon}}},
        {s: 'paymentArticles', p: {limit: -1, filter: {salon_id: this.salon}}},
        {s: 'cashbox', p: {limit: -1, filter: {salon_id: this.salon}}},
        {s: 'clients', p: {filter: {salon_id: this.salon}}},
        {s: 'workers', p: {limit: -1, filter: {salon_id: this.salon}}}
      ])
      await this.sortedData('desc', {dataIndex: 'date'})
      this.setFilters(this)
    } catch (e) {
      console.error(e)
    }
  }

  filtersCallback(filter: Array<Record<string, any>>): void {
    this.onApplyFilters();
  }

  setFilters(that: any): void {
    this.filtersData.filters.push(
      {
        key: 0,
        type: "datetimerange",
        label: i18nText("Период"),
        async onChange(value: any) {
          let filter = {}
          if (value.length === 0) {
            filter = {
              date_from: '0',
              date_to: '0'
            }
          } else {
            filter = {
              date_from: value[0].format("DD.MM.YYYY"),
              date_to: value[1].format("DD.MM.YYYY")
            }
          }
          await that.filterData(filter)
        },
        async onScroll(e) {
        },
        async onFocus() {
        },
        async onSearch(e) {
        }
      },
      {
        key: 1,
        type: "sourceVuex",
        label: i18nText("Назначение"),
        default_value: [i18nText("Не указано")],
        vuexSource: "paymentArticles",
        storeVuexSource: "paymentArticles",
        async onChange(value: any) {
          let filter = {};
          filter = {article_payment_id: value}
          await that.filterData(filter)
        },
        async onSearch(value: any) {
          await that.fetchModules([
            {
              s: 'paymentArticles', p: {
                filter: {
                  name: value,
                  salon_id: getStudioId(this)
                }
              }
            }
          ])
        },
        async onFocus() {
          await that.fetchModules([
            {
              s: 'paymentArticles', p: {
                limit: -1,
                filter: {
                  salon_id: getStudioId(this)
                }
              }
            }
          ])
        },
        async onScroll(e) {
        },
      },
      {
        key: 2,
        type: "select",
        label: i18nText("Тип"),
        default_value: [i18nText("Не указано")],
        value: this.financeOperation_type,
        async onChange(value: any) {
          let filter = {}

          if (Number(value)) {
            filter = {type: value}
          } else {
            filter = {type: "0"}
          }
          await that.filterData(filter)
        },
        onSearch(value: any) {
          that.filtersData.filters[2].value = that.financeOperation_type.filter((t: any) => {
            return t.label.toLowerCase().indexOf(value) !== -1
          })
        },
        onFocus() {
          that.filtersData.filters[2].value = that.financeOperation_type
        },
        async onScroll(e) {
        },
      },
      {
        key: 3,
        type: "sourceVuex",
        label: i18nText("Касса"),
        vuexSource: "items",
        storeVuexSource: "cashbox",
        default_value: [i18nText("Не указано")],
        async onChange(value: any) {
          let filter = {}
          filter = {cashbox_id: value}
          await that.filterData(filter);
        },
        async onSearch(value: any) {
          await that.handleSearch("cashbox", {name: value, salon_id: getStudioId(this)})
        },
        async onScroll(e) {
        },
        async onFocus() {
        }
      },
      {
        key: 4,
        type: "auto_complete",
        label: i18nText("Поиск по номеру клиента"),
        default_value: [i18nText("Не указано")],
        vuexSource: "clients",
        storeVuexSource: "clients",
        sel_op_first: i18nText("Имя: "),
        sel_op_second: i18nText("Тел.: "),
        async onSearch(value: string) {
          await that.handleSearch("clients", {
            phone: value,
            salon_id: getStudioId(this)
          })
        },
        async onChange(value: any) {
          let filter = {}
          if (!value) filter = {target_value: '0'}
          else if (value.length > 10) filter = {target_value: value.substr(0, 11)}
          await that.filterData(filter)
        },
        async onScroll() {
          that.handleScroll('clients', that.salon_id);
        },
        async onFocus() {
        }
      }
    )
    this.filter_load = true
  }


  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    await this.sortedData(by, {dataIndex: sort.dataIndex})
  }

  async clearFilter(clear: string): Promise<void> {
    await this.sortedData("desc", {dataIndex: "created_at"});
  }

  async clearAFilter(): Promise<void> {
    console.log("clearAFilter");
    this.proxyFilter = {
      salon_id: getStudioId(this),
    };
    for (let i of this.filtersData.filters) {
      i.default_value = [i18nText("Не указано")];
    }
    await this.sortedData("desc", {dataIndex: "created_at"});
  }
}
